import styled from 'styled-components';

import { buttonColors, ButtonColorTypes } from '~src/shared/buttons/basicButtons/BaseButton.sc';
import PrimaryButton from '~src/shared/buttons/basicButtons/PrimaryButton.sc';
import SvgIcon from '~src/shared/SvgIcon';
import { media } from '~src/styles/media-templates';

export const NavContainer = styled.section`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 40px;
  ${media.phone`
    width: 100%;
    justify-content: center;
    margin-top: 30px;
    height: 25px;
    flex-wrap: wrap;
  `}
`;

export const ProgressBarContainer = styled.div`
  width: 486px;
  height: 5px;
  background-color: ${({ theme }) => theme.white.a3};
  border-radius: 100px;
  border: 0;
  position: relative;
  ${media.phone`
    width: 158px;
  `}
`;

export const CenteredNoAnswerContainer = styled.div`
  display: none;
  width: 100%;
  ${media.phone`
    display: block;
  `}
`;

export const RightNoAnswerContainer = styled.div`
  ${media.phone`
    display: none;
  `}
`;

export const NoAnswerButton = styled(PrimaryButton)`
  color: ${(props) =>
    props.$highlighted ? buttonColors[ButtonColorTypes.Blue] : buttonColors[ButtonColorTypes.White]};
  background-color: ${(props) =>
    props.$highlighted ? buttonColors[ButtonColorTypes.White] : buttonColors[ButtonColorTypes.Blue]};
`;

export const ProgressBar = styled.span<{ $width: number }>`
  display: block;
  width: ${({ $width }) => $width}%;
  height: 5px;
  background-color: ${({ theme }) => theme.white.a10};
  border-radius: 2px;
  text-indent: -9999px;
  transition: width 0.3s ease;
  min-width: 5px;
  max-width: calc(100% - 5px);
`;

export const NavArrow = styled(SvgIcon)<{ $disabled?: boolean; $left?: boolean }>`
  color: white;
  cursor: pointer;
  opacity: ${({ $disabled }) => ($disabled ? 0 : 0.2)};
  display: ${({ $disabled }) => ($disabled ? 'none' : 'block')};
  transform: ${({ $left }) => ($left ? 'rotate(180deg)' : 'none')};
  &:hover {
    opacity: 1;
  }
`;

export const ArrowWrapper = styled.div`
  margin: 0 10px;
  width: 25px;
`;
